import React from 'react';
import ClassAssembly  from 'views/ClassAssembly1C';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;